import * as React from "react";
import {authorize, Overlay} from "@athena-portal/components";
import {Document, Types, ICustomerPortalService} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {trimFileExtension, downloadDocument} from "../../../../../CommonFunctions";

interface IProps {
    documents?: Document[]
}

interface IState {
    downloading: boolean;
}

@authorize
export class DocumentsPanel extends React.Component<IProps, IState> {
    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            downloading: false
        }
    }

    public downloadDocument(doc: Document): void {
        this.setState({
            downloading: true
        });

        this.customerPortalService.downloadDocument(doc.id).subscribe(
            (documentContent: ArrayBuffer) => {
                if (documentContent) {
                    downloadDocument(documentContent, doc.name);
                }
                this.setState({downloading: false});
            }
        );
    }

    public render() {
        if (this.props.documents && this.props.documents.length !== 0) {
            const documentsToRender = this.props.documents.map((document: Document, index: number) => {
                return (
                    <li className="document" key={index}>
                        <img className="document-icon" alt="Document icon" src="/img/Flow-download.svg"
                             onClick={() => this.downloadDocument(document)} tabIndex={0}/>
                        <div>
                            <a className="document-description" aria-label={`Document ${document.title}`} tabIndex={0}
                               onClick={() => this.downloadDocument(document)} id={trimFileExtension(document.name)}>
                                {document.title}
                            </a>
                        </div>
                    </li>
                );
            });

            return (
                <React.Fragment>
                    <ul className="list-unstyled document-list">
                        {documentsToRender}
                    </ul>
                    <Overlay show={this.state.downloading}/>
                </React.Fragment>
            );
        } else {
            return "";
        }
    }
}
